import React, { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  useBookingDispatch,
  useBookingState,
} from "../../hooks/useBookingState";
import { useMoney } from "../../hooks/useMoney";
import { useProdaName } from "../../hooks/useProdaName";
import { BookVal } from "../../utils/bookingUtils";
import { pickedProdAttr2Options } from "../../utils/productAttributeUtils";
import Utils from "../../utils/utils";
import { DropdownArea } from "../detail/DropdownArea";
import { SelectTagArea } from "../detail/SelectTagArea";

export const ProdAttrSingleCheckbox: FC<
  {
    names: ProdAttrNameSingleCheckbox[];
  } & ProdAttrPickerModeProps
> = (props) => {
  const { t } = useTranslation();
  const { formatMoney } = useMoney();
  const { names } = props;
  const { prodaName } = useProdaName();
  const bookingDispatch = useBookingDispatch(props);
  const bookingState = useBookingState(props);
  const bookingAttributes = bookingState.bookingAttributes;

  useEffect(() => {
    // Default select room 0
    const roomOptions = bookingAttributes?.filter(
      (attr) => attr.productAttribute.name === "ROOM_OPTION",
    );

    if (
      roomOptions?.length &&
      !roomOptions.some((attr) => attr.value?.quantity)
    ) {
      const defaultRoomOption = roomOptions.find((attr) =>
        attr.productAttribute?.variants?.some((variant) => variant.price === 0),
      );

      if (defaultRoomOption) {
        bookingDispatch.bookingPick(
          BookVal.overwrite(defaultRoomOption)({ quantity: 1 }),
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bookingAttributes]);

  return (
    <>
      {names.map((name) => {
        const availLs = bookingAttributes.filter(
          (x) => x.productAttribute.name === name,
        );
        if (!availLs.length) return null;
        const title =
          name === "ROOM_OPTION"
            ? t("Select Room type")
            : name === "EXTRA_OPTION"
              ? t("Select Option2")
              : prodaName(availLs[0]?.productAttribute);
        const onSelect = (
          values: {
            value: number;
          }[],
        ) => {
          bookingDispatch.bookingPickLs(
            availLs.map((booka) => {
              return {
                ...booka,
                value: !values.find(
                  (c) => c.value === booka.productAttribute.id,
                )
                  ? undefined
                  : {
                      quantity: (function () {
                        // if (name === "PREMIUM_PLUS") {
                        //   return Math.max(
                        //     ProdAttrUtils.countPerson(bookingState),
                        //     1,
                        //   );
                        // }
                        return 1;
                      })(),
                    },
              };
            }),
          );
        };

        const defaultSelected = [
          ...(availLs
            ?.filter((x) => x.value?.quantity)
            ?.map((x) => pickedProdAttr2Options(x, formatMoney))
            .map((x) => x.value) ?? []),
        ].filter((x) => x);
        const options = availLs
          .map((x) => pickedProdAttr2Options(x, formatMoney, t))
          .map((x) => ({
            value: x.value,
            displayName: x.displayName,
          }));
        return (
          <React.Fragment key={name}>
            {name === "LUGGAGE" || name === "AIRPORT" ? (
              <DropdownArea
                disabled={props.disabled}
                key={name}
                options={options}
                defaultSelected={defaultSelected}
                onSelect={onSelect}
                title={title}
              />
            ) : (
              <SelectTagArea
                containerClassName={`${props.mode === "POPUP" ? "!grid-cols-2" : ""}`}
                disabled={props.disabled}
                key={name}
                options={options}
                defaultSelected={defaultSelected}
                onSelect={onSelect}
                title={title}
              />
            )}
            {name === "ROOM_OPTION" && <RoomTypeConfigText {...props} />}
          </React.Fragment>
        );
      })}
    </>
  );
};

const RoomTypeConfigText: FC<ProdAttrPickerModeProps> = (props) => {
  const bookingAttributes = useBookingState({
    mode: props.mode,
  }).bookingAttributes;
  const selectedRoomOption: PaRoomTypeDTO | undefined = JSON.parse(
    bookingAttributes.find(
      (x) => x.productAttribute?.name === "ROOM_OPTION" && x.value?.quantity,
    )?.productAttribute?.meta ?? "{}",
  );
  const { formatMoney } = useMoney();
  const lang = Utils.getCurrentLanguage();
  return (
    <>
      {selectedRoomOption?.adultMaxNum && (
        <span className="mb-5 inline-block text-[13px] leading-[18px] text-[#5E6D77]">
          {lang === "ko"
            ? [
                !!selectedRoomOption?.adultMaxNum && (
                  <>객실당 성인 최대 {selectedRoomOption?.adultMaxNum}명,</>
                ),
                !!selectedRoomOption?.childMaxNum && (
                  <>
                    어린이 최대 {selectedRoomOption?.childMaxNum}명까지
                    가능합니다. <br /> 추가 인원 요금은{" "}
                  </>
                ),
                !!selectedRoomOption?.adultMaxFee && (
                  <>성인 {formatMoney(selectedRoomOption?.adultMaxFee)}; </>
                ),
                !!selectedRoomOption?.childMaxFee && (
                  <>어린이 {formatMoney(selectedRoomOption?.childMaxFee)}</>
                ),
                "입니다",
              ].filter((x) => x)
            : [
                !!selectedRoomOption?.adultMaxNum && (
                  <>
                    Maximum number of adult/ room is{" "}
                    {selectedRoomOption?.adultMaxNum};
                  </>
                ),
                !!selectedRoomOption?.childMaxNum && (
                  <>
                    {" "}
                    Child is {selectedRoomOption?.childMaxNum} <br /> Additional
                    fee is{" "}
                  </>
                ),
                !!selectedRoomOption?.adultMaxFee && (
                  <>{formatMoney(selectedRoomOption?.adultMaxFee)}/adult;</>
                ),
                !!selectedRoomOption?.childMaxFee && (
                  <> {formatMoney(selectedRoomOption?.childMaxFee)}/child</>
                ),
              ].filter((x) => x)}
        </span>
      )}
    </>
  );
};
